var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPpAttach = function SvgPpAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.111 2A1.89 1.89 0 0 1 19 3.889V17.11A1.89 1.89 0 0 1 17.111 19H3.89A1.889 1.889 0 0 1 2 17.111V3.89A1.889 1.889 0 0 1 3.889 2H17.11Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.933 12.133h2.917c1.75 0 2.52-.326 3.267-.956.746-.642 1.05-1.552 1.05-2.742 0-1.132-.292-2.018-1.05-2.742-.759-.688-1.482-1.026-3.267-1.026H5.833v11.666h2.1v-4.2ZM18.667 0A2.333 2.333 0 0 1 21 2.333v16.334A2.333 2.333 0 0 1 18.667 21H2.333A2.333 2.333 0 0 1 0 18.667V2.333A2.333 2.333 0 0 1 2.333 0h16.334ZM7.933 10.5V6.3h2.684c.77 0 1.365.292 1.75.7s.583.84.583 1.447c0 .653-.21 1.108-.583 1.47-.374.361-.817.583-1.61.583H7.933Z",
    fill: "#DA6800"
  })));
};
export default SvgPpAttach;